/**
 * De tekst links naast de toets: de titel en de alinea's, zoals de leerling
 * ze las. Met `markeer` staat die passage geel gemarkeerd; wat je als
 * kinderen meegeeft, komt onder de tekst.
 */
import React from 'react';
import { OpgemaakteTekst } from '../../../components/OpgemaakteTekst';
import { stijlen } from '../stijlen';

export function TekstPaneel({ titel, alineas, markeer = null, children }) {
  return (
    <div style={stijlen.toetsPaneel}>
      <h3 style={stijlen.paneelLabel}>De tekst</h3>
      <h2 style={stijlen.paneelTitel}>{titel}</h2>
      {alineas.map(p => (
        <div key={p.id} style={{ marginBottom: 16, lineHeight: 1.7 }}>
          <OpgemaakteTekst tekst={p.inhoud} markeer={markeer} />
        </div>
      ))}
      {children}
    </div>
  );
}
